import React from 'react';

export default function SocialButton({ url, label, hoverClass, children }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className={`cursor-pointer ${hoverClass}`}
    >
      <span className="sr-only">{label}</span>
      {children}
    </a>
  );
}
